export const colours = {
  primary: "#FF4800",
  accent: "#FF4800",
  background: "#F5F5F5",
  white: "#ffffff",
  black: "#000",
  border: "#d9d9d9",
};
